jQuery(function ($) {

  let smapInstances = new Map();

  async function loadSmap(container) {
    const API_KEY = 'D-Pvfrz_zPpWblSI6P-89YLgJv1xaG_AZsb0T178_9Q';
    const centerCoords = [49.9, 15.5]; // Czech Republic
    const data = $(container).data("markers");

    if (!smapInstances.has(container)) {
      const map = L.map(container, {
        center: centerCoords,
        zoom: 7,
        scrollWheelZoom: false
      });

      const tileLayer = L.tileLayer(`https://api.mapy.cz/v1/maptiles/outdoor/256/{z}/{x}/{y}?apikey=${API_KEY}`, {
        minZoom: 0,
        maxZoom: 19,
        attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
      });
      tileLayer.addTo(map);
      tileLayer.getContainer().style.filter = 'grayscale(100%) opacity(100%)';

      const LogoControl = L.Control.extend({
        options: { position: 'bottomleft' },
        onAdd: function () {
          const container = L.DomUtil.create('div');
          const link = L.DomUtil.create('a', '', container);
          link.href = 'https://mapy.cz/';
          link.target = '_blank';
          link.innerHTML = '<img src="https://api.mapy.cz/img/api/logo.svg" />';
          L.DomEvent.disableClickPropagation(link);
          return container;
        }
      });
      new LogoControl().addTo(map);

      const layerGroup = L.layerGroup().addTo(map);
      smapInstances.set(container, { map, layerGroup });
    } else {
      const { layerGroup } = smapInstances.get(container);
      layerGroup.clearLayers();
    }

    const { layerGroup } = smapInstances.get(container);
    const bounds = L.latLngBounds();

    data.forEach(item => {
      const icon = L.icon({
        iconUrl: item.icon,
        iconSize: [30, 40],
        iconAnchor: [15, 40],
        popupAnchor: [0, -40]
      });

      const marker = L.marker([item.lat, item.lng], { icon: icon });
      marker.bindPopup(item.html);

      if (item.link && item.link !== "") {
        marker.on("click", () => {
          window.open(item.link, '_blank');
        });
      }

      layerGroup.addLayer(marker);
      bounds.extend([item.lat, item.lng]);
    });

    const { map } = smapInstances.get(container);
    map.fitBounds(bounds);

  }

  $(".smap").each(function () {
    loadSmap(this);
  });

});
